import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateEnrollmentForm from "../../forms/CreateOrUpdateEnrollmentForm";

interface CreateEnrollmentModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateEnrollmentModal: React.FC<CreateEnrollmentModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="New Student Enrollment"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateEnrollmentForm loading={loading} error={error} />
  </AppModal>
);

export default CreateEnrollmentModal;
